<div class="onboarding-form">
  <h1>Business details</h1>
  @if (form) {
    <form
      [formGroup]="form"
      [boFormOptions]="options"
      (ngSubmit)="onSubmit()">
      <bo-non-field-errors />
      <app-form-field
        [boFieldPath]="'name'"
        [placeholder]="'Enter your business name'"
        [label]="'Business name'"
        [autocomplete]="'organization'"></app-form-field>
      <app-form-field
        [boFieldPath]="'size'"
        [placeholder]="'0 - 10'"
        [label]="'Business size'"></app-form-field>
      <app-form-field
        [boFieldPath]="'type'"
        [placeholder]="'Select business type'"
        [label]="'Business type &ast;'"></app-form-field>
      <div class="form-help-text">&ast; Only the business types in the list above are supported</div>
      <app-router-switch-btn
        title="Login"
        urlLink="/login"></app-router-switch-btn>
      <app-submit
        [busy]="busy"
        btnID="signupBizDetailSubmitBtn"
        label="Continue"></app-submit>
    </form>
  } @else {
    <app-loader></app-loader>
  }
</div>
